<!-- Clean, Simple Header matching the image -->
<header class="bg-white dark:bg-gray-800">
  <nav
    class="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
    aria-label="Global"
  >
    <!-- Logo with increased size -->
    <div class="flex lg:flex-1">
      <a routerLink="/" class="-m-1.5 p-1.5">
        <span class="sr-only">GraveNew</span>
        <img
          *ngIf="!darkMode"
          class="h-16 w-auto"
          src="../../../assets/logo/Logo.svg"
          alt="Logo"
        />
        <img
          *ngIf="darkMode"
          class="h-16 w-auto"
          src="../../../assets/logo/Logo-white.svg"
          alt="Logo"
        />
      </a>
    </div>

    <!-- Mobile menu button -->
    <div class="flex lg:hidden">
      <button
        type="button"
        class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700 dark:text-gray-300 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors duration-200"
        (click)="toggleMobileMenu()"
        [attr.aria-expanded]="isMobileMenuOpen"
        aria-controls="mobile-menu"
        aria-label="Toggle navigation menu"
      >
        <span class="sr-only">Open main menu</span>
        <svg
          class="size-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
          data-slot="icon"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          />
        </svg>
      </button>
    </div>

    <!-- Desktop navigation menu - simplified without dropdown -->
    <div class="hidden lg:flex lg:gap-x-12">
      <!-- Updated navbar links for grave search application -->
      <a
        routerLink="/"
        routerLinkActive="text-arabic-green dark:text-arabic-green-light"
        [routerLinkActiveOptions]="{ exact: true }"
        class="text-sm/6 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors duration-200 no-underline"
        >{{ "MENU.SEARCH" | translate }}</a
      >
      <a
        routerLink="/story"
        routerLinkActive="text-arabic-green dark:text-arabic-green-light"
        [routerLinkActiveOptions]="{ exact: false }"
        class="text-sm/6 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors duration-200 no-underline"
        >{{ "MENU.STORY" | translate }}</a
      >
      <!-- <a
        routerLink="/cemetery-map"
        routerLinkActive="text-arabic-green dark:text-arabic-green-light"
        [routerLinkActiveOptions]="{ exact: false }"
        class="text-sm/6 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors duration-200 no-underline"
        >{{ "MENU.CEMETERY_MAP" | translate }}</a
      >
      <a
        routerLink="/memorial-services"
        routerLinkActive="text-arabic-green dark:text-arabic-green-light"
        [routerLinkActiveOptions]="{ exact: false }"
        class="text-sm/6 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors duration-200 no-underline"
        >{{ "MENU.MEMORIAL_SERVICES" | translate }}</a
      >
      <a
        routerLink="/about"
        routerLinkActive="text-arabic-green dark:text-arabic-green-light"
        [routerLinkActiveOptions]="{ exact: false }"
        class="text-sm/6 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors duration-200 no-underline"
        >{{ "MENU.ABOUT_US" | translate }}</a
      > -->
      <!-- Management item with role-based access control -->
      <ng-container *appHasRole="['Admin', 'User']">
        <a
          routerLink="grave/management"
          routerLinkActive="text-arabic-green dark:text-arabic-green-light"
          [routerLinkActiveOptions]="{ exact: false }"
          class="text-sm/6 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors duration-200 no-underline"
          >{{ "MENU.MANAGEMENT" | translate }}</a
        >
      </ng-container>
    </div>

    <!-- Login button and Language switcher -->
    <div
      class="hidden lg:flex lg:flex-1 lg:justify-end lg:items-center lg:gap-x-6"
    >
      <!-- Language Switcher -->
      <button
        *ngIf="isBrowser"
        (click)="switchLanguage()"
        class="text-sm/6 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors flex items-center cursor-pointer gap-2"
        aria-label="Switch language"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
          />
        </svg>
        {{ languageLabel }}
      </button>

      <!-- Logout Button -->
      <button
        *ngIf="isLoggedIn"
        (click)="logout()"
        class="text-sm/6 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors duration-200 no-underline inline-flex items-center cursor-pointer"
      >
        {{ "MENU.LOGOUT" | translate }}
      </button>

      <!-- Login Button -->
      <a
        *ngIf="!isLoggedIn"
        routerLink="/login"
        class="text-sm/6 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors duration-200 no-underline inline-flex items-center"
        >{{ "MENU.LOGIN" | translate }}
        <span class="ml-1 rtl:rotate-180" aria-hidden="true">&rarr;</span></a
      >
    </div>
  </nav>

  <!-- Mobile menu - simplified -->
  <div
    [class.hidden]="!isMobileMenuOpen"
    class="lg:hidden fixed inset-0 z-50"
    id="mobile-menu"
    role="dialog"
    aria-modal="true"
  >
    <!-- Background backdrop with semi-transparent overlay -->
    <div
      id="mobile-menu-backdrop"
      (click)="closeMobileMenu()"
      class="fixed inset-0 bg-gray-600 bg-opacity-75 dark:bg-gray-900 dark:bg-opacity-75 transition-opacity"
    ></div>
    <div
      class="fixed inset-y-0 right-0 z-[60] w-full overflow-y-auto bg-white dark:bg-gray-800 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10 dark:sm:ring-gray-700/30 shadow-xl transform translate-x-0 transition-transform duration-300 ease-in-out"
    >
      <div class="flex items-center justify-between">
        <a routerLink="/" class="-m-1.5 p-1.5" (click)="closeMobileMenu()">
          <span class="sr-only">GraveNew</span>
          <!-- Arabic Light mode logo in mobile menu -->
          <img
            *ngIf="!darkMode"
            class="h-16 w-auto"
            src="../../../assets/logo/Logo.svg"
            alt="Logo"
          />
          <!-- Arabic Dark mode logo in mobile menu -->
          <img
            *ngIf="darkMode"
            class="h-16 w-auto"
            src="../../../assets/logo/Logo-white.svg"
            alt="Logo"
          />
        </a>
        <button
          type="button"
          class="-m-2.5 rounded-md p-2.5 text-gray-700 dark:text-gray-300 hover:text-arabic-green hover:dark:text-arabic-green-light transition-colors duration-200"
          (click)="closeMobileMenu()"
          aria-label="Close menu"
        >
          <span class="sr-only">Close menu</span>
          <svg
            class="size-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
            data-slot="icon"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div class="mt-6 flow-root">
        <div class="-my-6 divide-y divide-gray-500/10 dark:divide-gray-700/50">
          <div class="space-y-2 py-6">
            <a
              id="mobile-menu-search"
              routerLink="/"
              routerLinkActive="text-arabic-green dark:text-arabic-green-light bg-gray-50 dark:bg-gray-700"
              [routerLinkActiveOptions]="{ exact: true }"
              class="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light hover:bg-gray-50 hover:dark:bg-gray-700 transition-colors duration-200 no-underline"
              (click)="closeMobileMenu()"
              >{{ "MENU.SEARCH" | translate }}</a
            >
            <a
              id="mobile-menu-story"
              routerLink="/story"
              routerLinkActive="text-arabic-green dark:text-arabic-green-light bg-gray-50 dark:bg-gray-700"
              [routerLinkActiveOptions]="{ exact: false }"
              class="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light hover:bg-gray-50 hover:dark:bg-gray-700 transition-colors duration-200 no-underline"
              (click)="closeMobileMenu()"
              >{{ "MENU.STORY" | translate }}</a
            >
            <!-- <a
              id="mobile-menu-map"
              routerLink="/cemetery-map"
              routerLinkActive="text-arabic-green dark:text-arabic-green-light bg-gray-50 dark:bg-gray-700"
              [routerLinkActiveOptions]="{ exact: false }"
              class="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light hover:bg-gray-50 hover:dark:bg-gray-700 transition-colors duration-200 no-underline"
              (click)="closeMobileMenu()"
              >{{ "MENU.CEMETERY_MAP" | translate }}</a
            >
            <a
              id="mobile-menu-memorial"
              routerLink="/memorial-services"
              routerLinkActive="text-arabic-green dark:text-arabic-green-light bg-gray-50 dark:bg-gray-700"
              [routerLinkActiveOptions]="{ exact: false }"
              class="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light hover:bg-gray-50 hover:dark:bg-gray-700 transition-colors duration-200 no-underline"
              (click)="closeMobileMenu()"
              >{{ "MENU.MEMORIAL_SERVICES" | translate }}</a
            >
            <a
              id="mobile-menu-about"
              routerLink="/about"
              routerLinkActive="text-arabic-green dark:text-arabic-green-light bg-gray-50 dark:bg-gray-700"
              [routerLinkActiveOptions]="{ exact: false }"
              class="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light hover:bg-gray-50 hover:dark:bg-gray-700 transition-colors duration-200 no-underline"
              (click)="closeMobileMenu()"
              >{{ "MENU.ABOUT_US" | translate }}</a
            > -->
            <!-- Management item with role-based access control for mobile -->
            <ng-container *appHasRole="['Admin', 'User']">
              <a
                id="mobile-menu-management"
                routerLink="grave/management"
                routerLinkActive="text-arabic-green dark:text-arabic-green-light bg-gray-50 dark:bg-gray-700"
                [routerLinkActiveOptions]="{ exact: false }"
                class="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light hover:bg-gray-50 hover:dark:bg-gray-700 transition-colors duration-200 no-underline"
                (click)="closeMobileMenu()"
                >{{ "MENU.MANAGEMENT" | translate }}</a
              >
            </ng-container>
          </div>
          <div class="py-6">
            <!-- Language Switcher in Mobile Menu -->
            <button
              *ngIf="isBrowser"
              (click)="switchLanguage()"
              class="-mx-3 flex items-center gap-2 rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light hover:bg-gray-50 hover:dark:bg-gray-800 transition-colors duration-200 w-full text-left"
              aria-label="Switch language"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                />
              </svg>
              {{ "MENU.LANGUAGE" | translate }}: {{ languageLabel }}
            </button>

            <!-- Mobile menu login/logout -->
            <a
              *ngIf="!isLoggedIn"
              routerLink="/login"
              class="-mx-3 flex items-center rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light hover:bg-gray-50 hover:dark:bg-gray-800 transition-colors duration-200 no-underline mt-2"
              (click)="closeMobileMenu()"
              >{{ "MENU.LOGIN" | translate }}
              <span class="ml-1" aria-hidden="true">&rarr;</span></a
            >

            <button
              *ngIf="isLoggedIn"
              (click)="logout(); closeMobileMenu()"
              class="-mx-3 flex items-center rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 dark:text-gray-100 hover:text-arabic-green hover:dark:text-arabic-green-light hover:bg-gray-50 hover:dark:bg-gray-800 transition-colors duration-200 cursor-pointer w-full text-left mt-2"
            >
              {{ "MENU.LOGOUT" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
